<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="selected === undefined ? '12' : '6'">
        <v-list>
          <v-list-item-group v-model="selected">
            <v-list-item
              v-for="group in groupsData"
              :key="group.key"
            >
              <v-list-item-title>{{ group.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon v-if="group.id == 0">mdi-view-grid-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="selected !== undefined"
        cols="6"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="groupsData[selected].name"
                :rules="[rules.required, rules.length]"
                :label="$t('profile.sections.common.name')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    v-for="player in playersData"
                    :key="player.id_plyr"
                    class="pl-0"
                  >
                    <template>
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="isChecked(selected, player.id_plyr)"
                          @change="updatePlayersList(selected, player.id_plyr)"
                        />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ player.name }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
          <v-row v-if="groupsData[selected].id == 0">
            <v-col cols="12">
              <v-btn
                color="success"
                :disabled="!groupNameIsValid"
                @click="createGroup(groupsData[selected].id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.create") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="6">
              <v-btn
                color="primary"
                :disabled="!groupNameIsValid"
                @click="updateGroupData(groupsData[selected].id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <button-dialog-delete
                :text="$t('popup.group')"
                @ok-pushed="deleteGroup(groupsData[selected].id)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector.js";
import { ProfileGroupConnector } from "../Database/ProfileGroupConnector.js";

export default {
  components: {
    buttonDialogDelete,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      groupConnector: new ProfileGroupConnector(this.$store.state.user),
      selected: undefined,
      groupsData: [],
      playersData: [],
      myModel: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        length: (value) => value.length <= 25 || this.$t("field.max-25"),
      },
    };
  },
  computed: {
    groupNameIsValid() {
      return this.groupsData[this.selected].name.length > 0 && this.groupsData[this.selected].name.length <= 25;
    },
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getGroupsData();
      this.getAllPlayers();
    }
  },
  methods: {
    getGroupsData() {
      this.groupConnector
        .getGroupsData()
        .then((groups) => {
          groups.unshift({
            id: 0,
            name: this.$t("profile.sections.group.new"),
            players: [],
          });

          this.groupsData = groups;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllPlayers() {
      this.playerConnector
        .getAllPlayers()
        .then((players) => {
          this.playersData = players;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    createGroup() {
      if (this.groupNameIsValid) {
        this.groupConnector
          .insertGroupData(this.groupsData[this.selected])
          .then((group) => {
            this.groupsData.push(group);
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.create"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
    updateGroupData(gid) {
      if (this.groupNameIsValid) {
        this.groupConnector
          .updateGroupData(this.groupsData[this.selected], gid)
          .then(() => {
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.update"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
    deleteGroup(gid) {
      if (gid > 0) {
        this.groupConnector
          .deleteGroupData(gid)
          .then(() => {
            this.groupsData.splice(this.selected, 1);
            this.selected = undefined;
          })
          .catch((err) => {
            this.$store.dispatch("openSnackbar", {
              title: this.$t("dialog.warning"),
              txt: this.$t("error.delete"),
              colorBg: "red",
            });
            console.error(err);
          });
      }
    },
    isChecked(select, id) {
      return this.groupsData[select].players.includes(id);
    },
    updatePlayersList(select, id) {
      if (this.isChecked(select, id)) {
        this.groupsData[select].players = this.groupsData[select].players.filter((player) => player != id);
      } else {
        this.groupsData[select].players.push(id);
      }
    },
  },
};
</script>

<style>
.modal-mask {
  position: fixed;
  text-align: center;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.9s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
